import { Component } from "@angular/core";

@Component({
  selector: "app-avatar-info-popover",
  templateUrl: "./avatar-info-popover.component.html",
  styleUrls: ["./avatar-info-popover.component.scss"],
  standalone: false,
})
export class AvatarInfoPopoverComponent {
  avatarDetails: any = [];
  showLoader: boolean = false;
}
